import authApi from './axios-api';
// import EventBus from '../event-bus';

class GlobalRequest {
    async getRequest(url, body = null) {
        return await authApi
            .get(url, body)
            .then((res) => {
                return this.formatResponse(res);
            })
            .catch((err) => {
                return err;
            });
    }

    async postRequest(url, body) {
        return await authApi
            .post(url, body)
            .then((res) => {
                return this.formatResponse(res);
            })
            .catch((err) => {
                console.log(err)
                throw err;
            });
    }

    async patchRequest(url, body) {
        return await authApi
            .patch(url, body)
            .then((res) => {
                return this.formatResponse(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    async deleteRequest(url, body) {
        return await authApi
            .delete(url, body)
            .then((res) => {
                return this.formatResponse(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    formatResponse(res) {
        const statusCode = res.status.toString();
        if (statusCode.startsWith('2')) {
            return {
                statusCode: res.status,
                data: res.data.data,
                severity: 'success',
                summary: res.data.status,
                message: res.data.message,
            };
        }
    }
}

export default new GlobalRequest();
